import { render, staticRenderFns } from "./ComparisonData.vue?vue&type=template&id=47b4e382&scoped=true&"
import script from "./ComparisonData.vue?vue&type=script&lang=js&"
export * from "./ComparisonData.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonData.vue?vue&type=style&index=0&id=47b4e382&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4e382",
  null
  
)

export default component.exports